import { useEffect, useState } from "react";

/* Counts down to a target ISO date/time and renders remaining time.
   Turns amber under 24h and red once overdue. */
const CountdownTimer = ({ target }) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(interval);
    }, []);

    if (!target) return <span className="text-gray-400">–</span>;

    const diffMs = new Date(target).getTime() - now;
    const overdue = diffMs <= 0;
    const abs = Math.abs(diffMs);

    const totalMinutes = Math.floor(abs / 60000);
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    let color = "text-green-600";
    if (overdue) color = "text-red-600 font-semibold";
    else if (diffMs < 24 * 60 * 60 * 1000) color = "text-amber-600";

    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    parts.push(`${hours}h`);
    parts.push(`${minutes}m`);

    return (
        <span className={color}>
            {overdue ? "Försenad " : ""}{parts.join(" ")}
        </span>
    );
};

export default CountdownTimer;
